import { EntityType } from 'models/entity-permission.model';

const userKeys = {
    usersWithEntityPermission: (entityType: EntityType, entityId: string) => [
        'users',
        entityType,
        entityId,
    ],
};

export default userKeys;
